import axios from '@/utils/http'

/**
 *获取文章列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getArticleList (params) {
  return axios({
    url: '/ArticleService/ArticleManage/GetPublishArticleList',
    method: 'get', // default
    params: {
      ...params
    }
  })
}

/**
 *获取个人文章列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getOwnArticleList (params) {
  return axios({
    url: '/ArticleService/ArticleManage/GetOwnArticleList',
    method: 'get', // default
    params: {
      ...params
    }
  })
}

/**
 *添加文章
 *
 * @export
 * @param {*} data
 * @returns
 */
export function newArticle (params) {
  return axios({
    url: '/ArticleService/ArticleManage/CommitArticle',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *获取文章详情
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getArticle (params) {
  return axios({
    url: '/ArticleService/ArticleManage/GetOwnArticleDetail',
    method: 'get',
    params: params
  })
}

/**
 *编辑文章
 *
 * @export
 * @param {*} params
 * @returns
 */
export function editArticle (params) {
  return axios({
    url: '',
    method: 'post',
    data: params
  })
}

/**
 *删除文章
 *
 * @export
 * @param {*} id
 * @returns
 */
export function deleteArticle (id) {
  return axios({
    url: '/ArticleService/ArticleManage/RemoveArticle',
    method: 'post',
    data: {
      id
    }
  })
}

/**
 *发布文章
 *
 * @export
 * @param {*} id
 * @returns
 */
export function publishArticle (id) {
  return axios({
    url: '/ArticleService/ArticleManage/PublishArticle',
    method: 'post',
    data: {
      id
    }
  })
}

/**
 *上传文章图片
 *
 * @export
 * @param {*} params
 * @returns
 */
export function uploadImg (params) {
  return axios({
    url: '/ArticleService/ArticleManage/UploadFile',
    method: 'post',
    data: params
  })
}

/**
 *删除图片
 *
 * @export
 * @param {*} params
 * @returns
 */
export function deleteImg (params) {
  return axios({
    url: '/ArticleService/ArticleManage/RemoveFile',
    method: 'post',
    data: params
  })
}

/**
 *获取发布文章详情
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getArticleDetail (id) {
  return axios({
    url: '/ArticleService/ArticleManage/GetPublishArticleDetail',
    method: 'get',
    params: {
      id
    }
  })
}
